import React from 'react';
import { useLanguage } from '../../../../i18n/LanguageContext';

const DeleteConfirmModal = React.memo(({ deleteModal, setDeleteModal, handleDelete }) => {
  const { t } = useLanguage();

  if (!deleteModal) return null;

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setDeleteModal(null)}>
      <div className="delete-modal">
        <div className="modal-header">
          <h3>{t('productList.modal.deleteTitle', 'Ürün Sil')}</h3>
          <button className="modal-close" onClick={() => setDeleteModal(null)}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="delete-modal-body">
          <i className="fas fa-exclamation-triangle warning-icon"></i>
          <p>
            <strong>"{deleteModal.name}"</strong> {t('productList.modal.deleteConfirmQuestion', 'adlı ürünü silmek istediğinizden emin misiniz?')}
          </p>
          <p className="delete-warning">{t('productList.modal.deleteWarning', 'Bu işlem geri alınamaz.')}</p>
        </div>
        <div className="delete-modal-actions">
          <button className="btn-cancel" onClick={() => setDeleteModal(null)}>
            {t('common.cancel', 'İptal')}
          </button>
          <button className="btn-delete-confirm" onClick={handleDelete}>
            <i className="fas fa-trash"></i> {t('common.delete', 'Sil')}
          </button>
        </div>
      </div>
    </div>
  );
});

export default DeleteConfirmModal;
